<template>
  <section class="px-14 sm-max:px-5">
    <div class="mb-2 text-center sm-max:leading-3" v-if="extraButtonTopText">
      <span v-html="buttonTextTopBold" class="font-bold sm:text-xl text-12" />


      <br class="block sm:hidden">
      <span v-if="!extraButtonBottomText" class="italic sm:text-base text-12" v-html="buttonTextTopSmall">

      </span>
    </div>
    <div class="">
      <ButtonHealty :text="buttonText" :scrollTrigger :dataAttrs="{
        'data-event-label': buttonLabel,
        'data-event-action': buttonAction,
        'data-event-name': buttonEvent
      }" />
    </div>

    <div v-if="extraButtonBottomText" class="mt-1 italic text-center sm:text-base text-12" v-html="buttonTextTopSmall">

    </div>
  </section>
</template>

<script setup>

defineProps({
  buttonText: {
    type: String,
    default: 'SAVE 50% NOW'
  },
  extraButtonTopText: {
    type: Boolean,
    default: false
  },
  buttonTextTopBold: {
    type: String,
    default: 'LIMITED TIME OFFER: Get 50% off your first order (discount auto-applied)'
  },
  buttonTextTopSmall: {
    type: String,
    default: '(discount auto-applied)'
  },
  extraButtonBottomText: {
    type: Boolean,
    default: false
  },
  buttonLabel: {
    type: String
  },
  buttonAction: {
    type: String
  },
  buttonEvent: {
    type: String,
    default: 'experiment_event'
  },
  scrollTrigger: {
    type: String,
    default: "the-products"
  }
})


defineBuilderComponent({
    friendlyName: "ButtonABTest",
    canHaveChildren: true,
    inputs: [
        {
            name: "buttonText",
            type: "text",
            defaultValue: "SAVE 50% NOW"
        },
        {
            name: "extraButtonTopText",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "buttonTextTopBold",
            type: "richText",
            defaultValue: "LIMITED TIME OFFER: Get 50% off your first order"
        },
        {
            name: "buttonTextTopSmall",
            type: "richText",
            defaultValue: "(discount auto-applied)"
        },
        {
            name: "extraButtonBottomText",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "buttonLabel",
            type: "string"
        },
        {
            name: "buttonAction",
            type: "string"
        },
        {
            name: "buttonEvent",
            type: "string",
            defaultValue: "experiment_event"
        },
        {
            name: "scrollTrigger",
            type: "string",
            defaultValue: "the-products"
        }
    ]
});
</script>